import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import SiteHeader from "@/components/shop/SiteHeader";
import SiteFooter from "@/components/shop/SiteFooter";
import CartDrawer from "@/components/shop/CartDrawer";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) { setErr("Password must be at least 6 characters."); return; }
    setLoading(true);
    const res = await register(email, pw, name);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome, ${res.user.name}!`);
      navigate("/", { replace: true });
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50/50" data-testid="signup-page">
      <SiteHeader />
      <CartDrawer />
      <section className="mx-auto max-w-md px-5 sm:px-8 py-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-3xl border border-slate-100 p-8 shadow-sm">
          <p className="text-xs uppercase tracking-[0.25em] text-amber-500 font-bold">Join Morning Soft</p>
          <h1 className="mt-2 font-display text-3xl font-black text-[#0f2a5c]">Create an account</h1>
          <p className="mt-2 text-sm text-slate-500">Save details for faster checkout & leave verified reviews.</p>
          <form onSubmit={submit} noValidate className="mt-6 space-y-4" data-testid="signup-form">
            <div>
              <label className="text-xs uppercase font-bold tracking-widest text-slate-500 mb-2 block">Full name</label>
              <input data-testid="signup-name" required autoFocus value={name} onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[#173a7a]"/>
            </div>
            <div>
              <label className="text-xs uppercase font-bold tracking-widest text-slate-500 mb-2 block">Email</label>
              <input data-testid="signup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[#173a7a]"/>
            </div>
            <div>
              <label className="text-xs uppercase font-bold tracking-widest text-slate-500 mb-2 block">Password</label>
              <input data-testid="signup-password" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[#173a7a]"/>
              <p className="text-xs text-slate-400 mt-1">6+ characters</p>
            </div>
            {err && <p className="text-sm text-red-600" data-testid="signup-error">{err}</p>}
            <button data-testid="signup-submit" disabled={loading}
              className="w-full py-3.5 rounded-full bg-[#173a7a] text-white font-semibold hover:bg-[#1a4694] disabled:opacity-60">
              {loading ? "Creating account…" : "Create Account"}
            </button>
          </form>
          <p className="mt-6 text-sm text-slate-500 text-center">
            Already have an account?{" "}
            <Link to="/login" className="font-bold text-[#173a7a] hover:underline">Sign in</Link>
          </p>
        </motion.div>
      </section>
      <SiteFooter />
    </div>
  );
}
